/**
 * External dependencies
 */
import { Reducer } from 'redux';
import produce from 'immer';

/**
 * Internal dependencies
 */
import User from '@naruto/bgdapp/src/reducers/stores/user';
import USER_ACTION from '@naruto/bgdapp/src/reducers/cores/user/events';
import { CreateUserReducerParams, UserActionTypes } from './types';

export function createUserReducer(params: CreateUserReducerParams): Reducer<User, UserActionTypes> {
  return (state = params.initialState, action: UserActionTypes): User =>
    produce(state, _draft => {
      const draft = _draft;
      switch (action.type) {
        case USER_ACTION.SET_USER_INITIALIZE:
          draft.initialize();
          break;
        case USER_ACTION.SET_USER_INITIALIZE_APPLICATION:
          draft.initializeApplication();
          break;
        case USER_ACTION.SET_USER_LOGIN_STATE:
          draft.updateUserLoginState(action.isLogin);
          break;
        case USER_ACTION.SET_USER_AUTH_STATE:
          draft.updateUserAuthCheck(action.isAuth);
          break;
        case USER_ACTION.SET_USER_OAUTH_PROCESS_STATE:
          draft.updateUserOAuthProcess(action.isSuccess);
          break;
        case USER_ACTION.SET_USER_TOKEN_INFO:
          draft.updateUserTokenInfo(action.info);
          break;
        case USER_ACTION.SET_USER_SIGN_IN_OAUTH_URL:
          draft.updateUserSignInOAuthUrl(action.url);
          break;
        case USER_ACTION.SET_USER_SIGN_OUT_OAUTH_URL:
          draft.updateUserSignOutOAuthUrl(action.url);
          break;
        case USER_ACTION.SET_USER_PERMISSION_LIST:
          draft.updateUserPermissionList(action.permissions);
          break;
        case USER_ACTION.SET_USER_ROLE_LIST:
          draft.updateUserRoleList(action.roles);
          break;
        default:
          break;
      }
    });
}
